import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './SimpleFileUpload.html?raw';
import { FileUploadTypes } from "../Filetransfer/FileUpload/FileUploadTypes";
import { FileHelpers, TranslationHelpers } from "../../../more/Helpers";

/**
 * Einfaches Fileinput, das die Rückgabe der gewählten Files mit GetValue vereinfacht.
 * Upload wird nicht durchgeführt!
 */
class SimpleFileUpload extends compose(_WidgetBaseSP) {
    templateString: any = template;


    private formContainer: HTMLElement;
    private messageNode: HTMLElement;
    private fileInput: HTMLInputElement;

    submitCallback: any = null;
    private uploadIndividually: boolean = false; // TODO!
    multipleMode: boolean = false;
    private _filesToUpload: FileList = null;
    private _rawdata: Array<string> = null;
    maxSizeKB: number = 20 * 1024;
    private uploadUrl: string = "FileTransfer/SimpleFileUpload";
    private uploadProgress: number = 0;
    private uploadProgressTarget: number = 0;


    focus() {
        this.fileInput.focus();
    }
    private showSpinner(): void {
        this.StandbyStart();
    }

    private stopSpinner(): void {
        this.StandbyStop();
    }

    click(): void {
        if (this.fileInput) {
            this.fileInput.click();
        }
    }

    private _onClick_Upload(evt: MouseEvent): void {
        this.resetMessage();
        this.showSpinner();

            if (this._filesToUpload == null || this._filesToUpload.length == 0) {
                this.setMessage(this.translations["SimpleFileUpload__Message_NoFilesToUpload"]);
            return;
        }

        this._readFileContent();
    }

    private _StartUpload(additionalParams?: Object): void {

        let fileData: FileUploadTypes.SimpleFileUploadData = this.getUploadData();
        //console.debug("Filesize:", this._fileToUpload.size);
        let maxSizeB = this.maxSizeKB * 1024;
        if (fileData.totalSize > maxSizeB) {
            this._onUploadFileError({
                Message: this.stringFormat(TranslationHelpers.translate("SimpleFileUpload__Message_Oversize"),
                    FileHelpers.formatBytes(maxSizeB))
            });
            return;
        }

        this.showSpinner();

        let jsonData = fileData;

        if (additionalParams) {
            for (let param in additionalParams) {
                jsonData[param] = additionalParams[param];
            }
        }

        let url = window.appRoot + this.uploadUrl;

        //console.log(jsonData);

        if (this.uploadIndividually === true) {
            this.uploadProgressTarget = fileData.files.length;
            this.uploadProgress = 0;

            // TODO: pro file einzelner Aufruf...

        } else {
            this.uploadProgressTarget = 1;
            this.uploadProgress = 0;

            this.RequestManager.post(
                url,
                {
                    jsonData: JSON.stringify(jsonData)
                },
                lang.hitch(this, this._onUploadFileResponse),
                lang.hitch(this, this._onUploadFileError),
                false // sync
            );
        }
    }
    getValue(): FileUploadTypes.SimpleFileUploadData {
        return this.getUploadData();
    }
    getUploadData(): FileUploadTypes.SimpleFileUploadData {

        if (!this._filesToUpload || this._filesToUpload.length == 0) {
            return null;
        }

        let fileData: FileUploadTypes.SimpleFileUploadData = {
            totalSize: 0,
            files: []
        };

        for (let i = 0; i < this._filesToUpload.length; i++) {
            let file = this._filesToUpload[i];
            let rawData = this._rawdata[i];

            fileData.files.push({
                Base64Content: rawData,
                FileName: file.name,
                FileSize: file.size,
                FileType: file.type,
                LastModified: file.lastModified,
                Extension: null,
                FileGUID: file.name,
                removed:false
            })

            fileData.totalSize += file.size;
        }
        return fileData;
    }

    private _onUploadFileResponse(state: any): void {
        console.log("_onUploadFileResponse", state);

        this.uploadProgress++;

        if (this.uploadProgressTarget == this.uploadProgress) {

            this.stopSpinner();


            if (typeof (this.submitCallback) == "function") {
                this.submitCallback();
            }
        }
    }

    private _onUploadFileError(error: any): void {
        this.uploadProgress++;
        if (this.uploadProgressTarget == this.uploadProgress) {
            this.stopSpinner();
        }
        console.error("_onUploadFileError", error);
        this.setMessage(error.Message);
    }

    private _onChange_FileInput(evt: Event): void {
        //console.log("_onChange_FileInput", evt);
        this.resetMessage();
        let target: HTMLInputElement = <HTMLInputElement>evt.target;
        this._filesToUpload = target.files;

        this._readFileContent();
        //domAttr.set(this.fileSelectLabel, "innerHTML", this._fileToUpload.name);

        /*if (this._fileToUpload != null) {
            domClass.remove(this.actionContainer, "w3-hide");
        } else {
            domClass.add(this.actionContainer, "w3-hide");
        }*/
    }

    reset(): void {
        this._filesToUpload = null;
        this._rawdata = [];
        this._emitDelayedUpdate();
        this.fileInput.value = null;
    }

    private _readFileContent(): boolean {
        
        this._rawdata = [];

        if (!this._filesToUpload) {
            return false;
        }

        this.StandbyStart();

        for (let i = 0; i < this._filesToUpload.length; i++) {

            let file: File = this._filesToUpload[i];
            let reader: FileReader = new FileReader();

            //  hier wird der FileReader jedes File lesen und an Load bzw Error-Funktion übergeben
            //
            reader.onload = lang.hitch(this, this._onFileReader_Load, reader);
            reader.onerror = lang.hitch(this, this._onFileReader_Error);

            reader.readAsDataURL(file);
            //console.log("reading file...", reader, file);
        }
        return true; // zurückmelden, dass der upload-vorgang angeworfen wurde. hat aber noch keine aussage darüber ob er erfolgreich beendet wurde!
    }

    private _onFileReader_Load(reader: FileReader): void {
        //  Der FileReader konnte das File ohne Fehler lesen
        //
        let Base64Content = <string>reader.result;
        this._rawdata.push(Base64Content);

        this._emitDelayedUpdate();

        this.stopSpinner();
     //this._uploadFile();
    }

    private _onFileReader_Error(error: any): void {
        console.log("_onFileReader_Error", error);
    }

    private _emitTimeout: number = null;
    private _emitDelayedUpdate(): void {
        if (this._emitTimeout != null) {
            clearTimeout(this._emitTimeout);
            this._emitTimeout = null;
        }

        setTimeout(lang.hitch(this, this.emit, "change"), 100);
    }

    setMessage(message: string): void {
        //domClass.add(this.employmentSelectContainer, "w3-hide");
        this.UiModder.domAttr.set(this.messageNode, "innerHTML", message);

        //this._timeoutFct = setTimeout(lang.hitch(this, "resetMessage"), 4000);
    }


    private _setMaxSizeAttr(valueMB: number): void {
        this.maxSizeKB = valueMB * 1024;
    }

    private _setSubmitCallbackAttr(callback: Function): void {
        this.submitCallback = callback;
    }  

    resetMessage(): void {
        //domClass.remove(this.employmentSelectContainer, "w3-hide");
        this.UiModder.domConstruct.empty(this.messageNode);
    }

    private _setMultipleModeAttr(value: boolean) {
        this.multipleMode = value === true;
        this.fileInput.multiple = this.multipleMode;
    }

    private _setUploadUrlAttr(value: string) {
        this.uploadUrl = value;
    }
   

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.UiModder.domClass.remove(this.formContainer, "w3-hide");

        this._setMultipleModeAttr(this.multipleMode);

    }
}

export default mdsWidget(SimpleFileUpload);